import useApi from 'common/ApiMiddlewere'
import { dateFormat } from 'pages/Common'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-hot-toast'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { Card, CardBody, Col, Row, Table } from "reactstrap"
import { map } from "lodash"
import noImage from "../../assets/images/no_image.jpg"

const InvoiceDetalis = ({ toggle, modal, bookingId }) => {
    const { getApi } = useApi()

    const [invoiceDetails, setInvoiceDetails] = useState()
    const [invoiceTable, setinvoiceTable] = useState()
    const [imageModal, setImageModal] = useState(false)
    const [clickImageURL, setClickImageURL] = useState('')
    // const CGST = parseFloat(localStorage.getItem("GST").split("|")[0] || 0)
    // const SGST = parseFloat(localStorage.getItem("GST").split("|")[1] || 0)
    // const IGST = CGST + SGST

    useEffect(() => {
        if (bookingId) {
            getApi(`Booking/invoice-detail?id=${String(bookingId)}`).then(
                ({ data, status }) => {
                    if (status === 200) {
                        setInvoiceDetails(data.InvoiceDetail)
                        setinvoiceTable(data.ProductList)
                    } else {
                        toast.error(data, {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    }
                }
            )
        }

    }, [bookingId])

    const imageToggle = () => {
        setImageModal(!imageModal)
    }

    const handleClose = () => {
        setImageModal(!imageModal)
    }

    const handleImageClick = (Image) => {
        setClickImageURL(Image)
        setImageModal(true)
    }

    return (
        <div>
            <Modal isOpen={modal} toggle={toggle} centered={true} size="xl">
                <div className="modal-content">
                    <ModalHeader className="text-centre" toggle={toggle} tag="h5">
                        <span style={{ fontWeight: "600", fontSize: "20px", marginLeft: "8px" }}> Bill Details </span>
                    </ModalHeader>
                    <ModalBody>
                        <React.Fragment>
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="p-1">
                                            <Row>
                                                <Col sm="5" className="text-sm-start">
                                                    <address style={{ marginBottom: "4px" }}> <span style={{ fontSize: "16px", fontWeight: "600" }}>
                                                        Customer Details</span>
                                                        <br />
                                                        <span style={{ fontSize: "15px", fontWeight: "600" }}>
                                                            Name: </span>
                                                        <span style={{ fontSize: "14px" }}>{invoiceDetails?.CustomerName}</span>
                                                        <br />
                                                        <span style={{ fontSize: "15px", fontWeight: "600" }}>
                                                            Contact: </span>
                                                        <span style={{ fontSize: "14px" }}>
                                                            {invoiceDetails?.ContactNo1} || {invoiceDetails?.ContactNo2}
                                                        </span>
                                                    </address>
                                                    <div>
                                                        <address> <span style={{ fontSize: "15px", fontWeight: "600" }}>
                                                            Address: </span>
                                                            <span style={{ fontSize: "14px" }}>{invoiceDetails?.CustomerAddress}</span>
                                                            <br />
                                                            <div>
                                                                <span style={{ fontSize: "15px", fontWeight: "600" }}>
                                                                    GSTIN.:  </span>
                                                                <span style={{ fontSize: "14px" }}>{invoiceDetails?.CustomerGSTNo || 'N/A'}</span>
                                                            </div>
                                                        </address>
                                                    </div>
                                                </Col>
                                                <Col sm="7" className="text-end">
                                                    <h4 style={{ marginBottom: "5px" }}>
                                                        <span style={{ fontSize: "16px", fontWeight: "600" }}> Bill No:</span> <span style={{ fontSize: "14px" }}> {invoiceDetails?.BillNo}</span>
                                                    </h4>
                                                    <address className="mb-0">
                                                        <span style={{ fontSize: "16px", fontWeight: "600" }}>
                                                            Date: </span>
                                                        <span style={{ fontSize: "14px" }}>
                                                            {
                                                                invoiceDetails?.BillDate
                                                            }</span>
                                                        <br />
                                                        <br />
                                                    </address>
                                                </Col>
                                            </Row>
                                            <Row className="py-2 mt-1">
                                                <Col sm={4}><div >
                                                    <h3 className="font-size-16" style={{ fontWeight: "600" }}>Product Detail</h3>
                                                </div></Col>
                                                <Col sm={8} className="text-end" style={{ color: "#35ab51" }}>
                                                    <h3 className="font-size-16" style={{ fontWeight: "500" }}> Deposit:
                                                        <span style={{ fontSize: "14px" }}>
                                                            <i className="mdi mdi-currency-inr"></i>
                                                            {new Intl.NumberFormat('en-IN', {
                                                                currency: 'INR',
                                                                minimumFractionDigits: 2,
                                                            }).format(invoiceDetails?.Deposit || 0)}
                                                        </span>
                                                    </h3>
                                                </Col>
                                            </Row>
                                            <div className="table-responsive">
                                                <Table className="table-nowrap" bordered>
                                                    <thead>
                                                        <tr>
                                                            <th className="custom-header-invoice" style={{ width: "20px" }}>No.</th>
                                                            <th className="custom-header-invoice" style={{ width: "20px" }}>Image</th>
                                                            <th className="custom-header-invoice" style={{ width: "30px" }}>Code</th>
                                                            <th className="custom-header-invoice" >Product Name</th>
                                                            <th className="custom-header-invoice" style={{ width: "30px" }}>Status</th>
                                                            <th className="custom-header-invoice" style={{ width: "40px" }}>Delivery Date</th>
                                                            <th className="custom-header-invoice" style={{ width: "40px" }}>
                                                                Return Date
                                                            </th>
                                                            <th className="custom-header-invoice text-end" style={{ width: "60px" }}>
                                                                Rent
                                                            </th>
                                                            {/* <th className="custom-header-invoice text-end" style={{ width: "60px" }}>
                                                                CGST ({invoiceDetails?.IGSTAmount == 0 ? CGST : 0}%)
                                                            </th>
                                                            <th className="custom-header-invoice text-end" style={{ width: "60px" }}>
                                                                SGST ({invoiceDetails?.IGSTAmount == 0 ? SGST : 0}%)
                                                            </th> */}

                                                            <th className="custom-header-invoice text-end" style={{ width: "60px" }}>
                                                                CGST({invoiceDetails?.IGSTAmount == 0 ? invoiceTable[0]?.CGSTPer : 0}%)
                                                            </th>
                                                            <th className="custom-header-invoice text-end" style={{ width: "60px" }}>
                                                                SGST ({invoiceDetails?.IGSTAmount == 0 ? invoiceTable[0]?.SGSTPer : 0}%)
                                                            </th>


                                                            <th className="custom-header-invoice text-end" style={{ width: "60px" }}>
                                                                IGST ({invoiceDetails?.IGSTAmount > 0 ? invoiceTable[0]?.IGSTPer
                                                                    : 0}%)
                                                            </th>
                                                            <th className="custom-header-invoice text-end" style={{ width: "60px" }}>
                                                                Total Amt.
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {map(invoiceTable, (item, key) => (
                                                            <tr key={key}>
                                                                <td className='custom-header1'>{key + 1}</td>
                                                                <td className='custom-header1'>
                                                                    <div
                                                                        style={{
                                                                            width: "40px",
                                                                            height: "40px",
                                                                            border: "1px solid #ced4da",
                                                                            cursor: "pointer",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            borderRadius: "3px",
                                                                        }}
                                                                    >
                                                                        <img
                                                                            onClick={() => handleImageClick(item.ProductImage ? item.ProductImage : noImage)}
                                                                            className="img-fluid"
                                                                            style={{}}
                                                                            src={item.ProductImage ? item.ProductImage : noImage}
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td className='custom-header1'>{item.ProductCode}</td>
                                                                <td className='text-wrap custom-header1' >{item.ProductTitle} <div style={{ fontSize: '11px' }}
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: item?.DyanamicData
                                                                        ,
                                                                    }}
                                                                /></td>
                                                                <td className='custom-header1'>{item.Status == 1 ? "Booked" : item.Status == 2 ? "Delivered" : item.Status == 3 ? "Return" : "Cancel"}</td>
                                                                <td className='custom-header1' style={{ width: "40px" }}>
                                                                    {dateFormat(
                                                                        item.DeliveryDate.split("T")[0],
                                                                        "dd/MM/yyyy"
                                                                    )}
                                                                    <br />
                                                                    {item.DeliveryTimeSlot ? (
                                                                        <span> {` (${item.DeliveryTimeSlot})`}</span>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </td>
                                                                <td className='custom-header1' style={{ width: "40px" }}>
                                                                    {dateFormat(
                                                                        item.ReturnDate.split("T")[0],
                                                                        "dd/MM/yyyy"
                                                                    )}
                                                                    <br />
                                                                    {item.ReturnTimeSlot ? (
                                                                        <span> {` (${item.ReturnTimeSlot})`}</span>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </td>
                                                                <td className="text-sm-end custom-header1">
                                                                    <i className="mdi mdi-currency-inr"></i>
                                                                    {new Intl.NumberFormat('en-IN', {
                                                                        currency: 'INR',
                                                                        minimumFractionDigits: 2,
                                                                    }).format((item?.Rent).toFixed(2) || 0)}
                                                                </td>
                                                                <td className="text-sm-end custom-header1">
                                                                    <i className="mdi mdi-currency-inr"></i>
                                                                    {new Intl.NumberFormat('en-IN', {
                                                                        currency: 'INR',
                                                                        minimumFractionDigits: 2,
                                                                    }).format((item?.CGSTAmount).toFixed(2) || 0)}
                                                                </td>
                                                                <td className="text-sm-end custom-header1">
                                                                    <i className="mdi mdi-currency-inr"></i>
                                                                    {new Intl.NumberFormat('en-IN', {
                                                                        currency: 'INR',
                                                                        minimumFractionDigits: 2,
                                                                    }).format((item?.SGSTAmount).toFixed(2) || 0)}
                                                                </td>
                                                                <td className="text-sm-end custom-header1">
                                                                    <i className="mdi mdi-currency-inr"></i>
                                                                    {new Intl.NumberFormat('en-IN', {
                                                                        currency: 'INR',
                                                                        minimumFractionDigits: 2,
                                                                    }).format((item?.IGSTAmount).toFixed(2) || 0)}
                                                                </td>
                                                                <td className="text-sm-end custom-header1">
                                                                    <i className="mdi mdi-currency-inr"></i>
                                                                    {new Intl.NumberFormat('en-IN', {
                                                                        currency: 'INR',
                                                                        minimumFractionDigits: 2,
                                                                    }).format(item?.NetRent || 0)}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        <tr>
                                                            <td rowSpan={7}
                                                                colSpan={8}
                                                                className="custom-header-invoice"
                                                            >
                                                                <span style={{ fontSize: "14px", fontWeight: "600" }}>Remarks :</span>
                                                                <br />
                                                                <div className='text-wrap'
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: invoiceDetails?.Remarks
                                                                        ,
                                                                    }}>
                                                                </div>
                                                            </td>
                                                            <td style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                CGST Amt.
                                                            </td>
                                                            <td style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                <i className="mdi mdi-currency-inr"></i>
                                                                {new Intl.NumberFormat('en-IN', {
                                                                    currency: 'INR',
                                                                    minimumFractionDigits: 2,
                                                                }).format(invoiceDetails?.CGSTAmount || 0)}
                                                            </td>
                                                            <td style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                Taxable Amt.
                                                            </td>
                                                            <td style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                <i className="mdi mdi-currency-inr"></i>
                                                                {new Intl.NumberFormat('en-IN', {
                                                                    currency: 'INR',
                                                                    minimumFractionDigits: 2,
                                                                }).format(invoiceDetails?.TotalRent || 0)}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                SGST Amt.
                                                            </td>
                                                            <td style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                <i className="mdi mdi-currency-inr"></i>
                                                                {new Intl.NumberFormat('en-IN', {
                                                                    currency: 'INR',
                                                                    minimumFractionDigits: 2,
                                                                }).format(invoiceDetails?.SGSTAmount || 0)}
                                                            </td>
                                                            <td style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                Taxes(+)
                                                            </td>
                                                            <td style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                <i className="mdi mdi-currency-inr"></i>
                                                                {new Intl.NumberFormat('en-IN', {
                                                                    currency: 'INR',
                                                                    minimumFractionDigits: 2,
                                                                }).format(invoiceDetails?.IGSTAmount > 0 ? invoiceDetails?.IGSTAmount : invoiceDetails?.CGSTAmount + invoiceDetails?.SGSTAmount || 0)}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                rowSpan={1}
                                                                // colSpan={2}
                                                                style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                IGST Amt.
                                                            </td>
                                                            <td
                                                                rowSpan={1}
                                                                style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                <i className="mdi mdi-currency-inr"></i>
                                                                {new Intl.NumberFormat('en-IN', {
                                                                    currency: 'INR',
                                                                    minimumFractionDigits: 2,
                                                                }).format(invoiceDetails?.IGSTAmount || 0)}
                                                            </td>
                                                            <td style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                Net Amt.
                                                            </td>
                                                            <td style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                <i className="mdi mdi-currency-inr"></i>
                                                                {new Intl.NumberFormat('en-IN', {
                                                                    currency: 'INR',
                                                                    minimumFractionDigits: 2,
                                                                }).format(Math.round(invoiceDetails?.NetAmount + invoiceDetails?.Discount)) || 0}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                rowSpan={1}
                                                                className="border-0 text-end custom-header-invoice">
                                                            </td>
                                                            <td
                                                                rowSpan={1}
                                                                // colSpan={2}
                                                                className="border-0 text-end custom-header-invoice">
                                                            </td>
                                                            <td style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                Discount(-)
                                                            </td>
                                                            <td style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                <i className="mdi mdi-currency-inr"></i>
                                                                {new Intl.NumberFormat('en-IN', {
                                                                    currency: 'INR',
                                                                    minimumFractionDigits: 2,
                                                                }).format(invoiceDetails?.Discount || 0)}
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td
                                                                rowSpan={1}
                                                                className="border-0 text-end custom-header-invoice">
                                                            </td>
                                                            <td
                                                                rowSpan={1}
                                                                // colSpan={2}
                                                                className="border-0 text-end custom-header-invoice">
                                                            </td>
                                                            <td
                                                                rowSpan={1}
                                                                // colSpan={2}
                                                                style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                Credit Note Amt.(-)
                                                            </td>
                                                            <td
                                                                rowSpan={1}
                                                                style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                <i className="mdi mdi-currency-inr"></i>
                                                                {new Intl.NumberFormat('en-IN', {
                                                                    currency: 'INR',
                                                                    minimumFractionDigits: 2,
                                                                }).format(invoiceDetails?.CreditNoteAmount || 0)}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                rowSpan={1}
                                                                className="border-0 text-end custom-header-invoice">
                                                            </td>
                                                            <td
                                                                rowSpan={1}
                                                                // colSpan={2}
                                                                className="border-0 text-end custom-header-invoice">
                                                            </td>
                                                            <td
                                                                rowSpan={1}
                                                                // colSpan={2}
                                                                style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                Advance(-)
                                                            </td>
                                                            <td
                                                                rowSpan={1}
                                                                style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                <i className="mdi mdi-currency-inr"></i>
                                                                {new Intl.NumberFormat('en-IN', {
                                                                    currency: 'INR',
                                                                    minimumFractionDigits: 2,
                                                                }).format(invoiceDetails?.Advance || 0)}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                rowSpan={1}
                                                                className="border-0 text-end custom-header-invoice">
                                                            </td>
                                                            <td
                                                                rowSpan={1}
                                                                // colSpan={2}
                                                                className="border-0 text-end custom-header-invoice">
                                                            </td>
                                                            <td
                                                                rowSpan={1}
                                                                // colSpan={2}
                                                                style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                Payable Amt.
                                                            </td>
                                                            <td
                                                                rowSpan={1}
                                                                style={{ fontWeight: "600" }} className="border-0 text-end custom-header-invoice">
                                                                <i className="mdi mdi-currency-inr"></i>
                                                                {new Intl.NumberFormat('en-IN', {
                                                                    currency: 'INR',
                                                                    minimumFractionDigits: 2,
                                                                }).format(Math.round(invoiceDetails?.NetAmount) - (invoiceDetails?.Advance) - (invoiceDetails?.CreditNoteAmount) || 0)}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </React.Fragment >
                    </ModalBody>
                </div>
            </Modal >

            <Modal isOpen={imageModal} toggle={imageToggle} centered={true} size="small"
                style={{ width: "350px", background: "transparent" }} >
                <ModalBody style={{ display: "flex", alignItems: "center", justifyContent: "center", background: "transparent" }}>
                    <React.Fragment>
                        <Row>
                            <div
                                style={{
                                    // width: "270px",
                                    // height: "270px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <img
                                    style={{ width: "230px" }}
                                    className="img-fluid"
                                    src={clickImageURL}
                                />
                            </div>
                            <div
                                style={{
                                    top: "2px",
                                    cursor: "pointer",
                                    left: "310px",
                                    position: "absolute",
                                }}
                            >
                                <span onClick={handleClose}> <i className='fs-2 bx bx-x'></i></span>
                            </div>
                        </Row>
                    </React.Fragment >
                </ModalBody>
            </Modal>

        </div >
    )
}

export default InvoiceDetalis